import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  ApolloLink,
  from,
} from "@apollo/client/core"
import { setContext } from "@apollo/client/link/context"
import { CachePersistor, LocalStorageWrapper } from "apollo3-cache-persist"
import { persistenceMapper } from "./apollo.js"

// import {
//   IntrospectionFragmentMatcher,
//   InMemoryCache
// } from 'apollo-cache-inmemory'

//import { createUploadLink } from 'apollo-upload-client'
import { createApolloProvider } from "@vue/apollo-option"
import { provideApolloClient } from "@vue/apollo-composable"

import { uuidv4 } from "./assets/js/uuid"
//import gitVersion from './generated/gitInfo.js'

// Name of the localStorage item
const AUTH_TOKEN = "apollo-token"

// Http endpoint
const httpEndpoint = import.meta.env.VITE_GRAPHQL_HTTP || "/graphql/"

// {
//   fragmentMatcher,
//   dataIdFromObject: object => {
//     switch (object.__typename) {
//       case 'ImageData':
//         return object.__typename + ':' + object.id + ':' + object.type
//       case 'Template':
//         return object.__typename + ':' + object.path
//       case 'PublisherCampaign':
//         return object.__typename + ':' + object.id + ':' + object.publisherId
//       case 'Country':
//         return object.__typename + ':' + object.code
//       case 'Tag':
//         if (object.pivot) {
//           return (
//             object.__typename +
//             ':' +
//             object.pivot.tagId +
//             ':' +
//             object.pivot.taggableId +
//             ':' +
//             object.pivot.taggableType
//           )
//         }
//         return object.__typename + ':' + object.id
//     }
//     if (object.__typename && object.id) {
//       return object.__typename + ':' + object.id
//     }
//     if (object.__typename && object._id) {
//       return object.__typename + ':' + object._id
//     }
//     return
//   }
// }

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: httpEndpoint,
})

// Cache implementation
const cache = new InMemoryCache({
  typePolicies: {
    ImageData: {
      keyFields: ["id", "type"],
    },
    Tag: {
      keyFields: ['slug', 'type', 'isNot']
    },
    Payout: {
      keyFields: ["id", "isGlobalPayout"],
    },
  },
})

// Cache Persistor setup... modify persistenceMapper to only persist the queries you want
// const persistor = new CachePersistor({
//   cache,
//   storage: new LocalStorageWrapper(window.localStorage),
//   persistenceMapper,
// });
// await persistor.restore();

const APP_INSTANCE_ID = uuidv4()

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = localStorage.getItem(AUTH_TOKEN)
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null,
      "ytrack-app-instance": APP_INSTANCE_ID,
    },
  }))

  return forward(operation)
})

export function createProvider(options = {}) {
  const apolloClient = new ApolloClient({
    link: from([authMiddleware, httpLink]),
    httpEndpoint,
    tokenName: AUTH_TOKEN,
    persisting: false,
    websocketsOnly: false,
    ssr: false,
    cache,
    apollo: {
      //link: link,
      name: "offer-studio",
      // version: gitVersion
    },
  })

  provideApolloClient(apolloClient)

  const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: "cache-first",
      },
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log(
        "%cError",
        "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;",
        error.message,
      )
    },
  })

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (typeof localStorage !== "undefined" && token) {
    localStorage.setItem(AUTH_TOKEN, token)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("%cError on cache reset (login)", "color: orange;", e.message)
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("%cError on cache reset (logout)", "color: orange;", e.message)
  }
}
